const {CardDeck, MilitaryCardTypes}  = require("../../Constants/Names/CardTypes");
const Card = require("./Card");

class EventCard extends Card{
    constructor(event)
    {
        super(
            CardDeck.Military,
            MilitaryCardTypes.Event,
            null,
            event.GetName(),
            event.GetAge(),
            event.GetText(),
            event.GetEffects(),
        )
        this.event = event;
    }
}

module.exports = EventCard;